const base = '/providers'

export const providers = {
    get_providers: `${base}/`,
    get_staff_with_available_time: `${base}/staff-with-available-time`,
    get_staff_with_time: `${base}/staff-with-time`
}